import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

import SiteLogo from "components/SiteLogo";

import { navData } from "data/nav";

const Nav = () => {
  return (
    <div className="footer-nav">
      <SiteLogo />
      <ul>
        {navData.map((item, index) => (
          <li key={index}>
            <Link to={item.url}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Nav;
